import { TenantEntity } from '../TenantEntity'

export class TrackingInfo extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'TrackingInfo'
  }
  get changeAble() {
    return this._data.changeAble
  }
  set changeAble(changeAble) {
    this._data.changeAble = changeAble
  }

  get modifyByChineseName() {
    return this._data.modifyByChineseName
  }
  set modifyByChineseName(modifyByChineseName) {
    this._data.modifyByChineseName = modifyByChineseName
  }

  get modifyDateHour() {
    return this._data.modifyDateHour
  }
  set modifyDateHour(modifyDateHour) {
    this._data.modifyDateHour = modifyDateHour
  }
  get isDirty() {
    return this._data.isDirty
  }
  set isDirty(isDirty) {
    this._data.isDirty = isDirty
  }
  get modifyDateMins() {
    return this._data.modifyDateMins
  }
  set modifyDateMins(modifyDateMins) {
    this._data.modifyDateMins = modifyDateMins
  }
  get code() {
    return this._data.code
  }
  set code(code) {
    if (this._data.code === code) return
    this._data.isDirty = true
    this._data.code = code
  }
  get codeCname() {
    return this._data.codeCname
  }
  set codeCname(codeCname) {
    if (this._data.codeCname === codeCname) return
    this._data.isDirty = true
    this._data.codeCname = codeCname
  }
  get codeEname() {
    return this._data.codeEname
  }
  set codeEname(codeEname) {
    if (this._data.codeEname === codeEname) return
    this._data.isDirty = true
    this._data.codeEname = codeEname
  }
  get subCode() {
    return this._data.subCode
  }
  set subCode(subCode) {
    if (this._data.subCode === subCode) return
    this._data.isDirty = true
    this._data.subCode = subCode
  }
  get subCodeCname() {
    return this._data.subCodeCname
  }
  set subCodeCname(subCodeCname) {
    if (this._data.subCodeCname === subCodeCname) return
    this._data.isDirty = true
    this._data.subCodeCname = subCodeCname
  }
  get subCodeEname() {
    return this._data.subCodeEname
  }
  set subCodeEname(subCodeEname) {
    if (this._data.subCodeEname === subCodeEname) return
    this._data.isDirty = true
    this._data.subCodeEname = subCodeEname
  }
  get modifyDate() {
    return this._data.modifyDate
  }
  set modifyDate(modifyDate) {
    if (this._data.modifyDate === modifyDate) return
    this._data.isDirty = true
    this._data.modifyDate = modifyDate
  }
  get modifyBy() {
    return this._data.modifyBy
  }
  set modifyBy(modifyBy) {
    if (this._data.modifyBy === modifyBy) return
    this._data.isDirty = true
    this._data.modifyBy = modifyBy
  }
  get remark() {
    return this._data.remark
  }
  set remark(remark) {
    if (this._data.remark === remark) return
    this._data.isDirty = true
    this._data.remark = remark
  }
  get roleType() {
    return this._data.roleType
  }
  set roleType(roleType) {
    if (this._data.roleType === roleType) return
    this._data.isDirty = true
    this._data.roleType = roleType
  }
  get jobUuid() {
    return this._data.jobUuid
  }
  set jobUuid(jobUuid) {
    this._data.jobUuid = jobUuid
  }
  get trackingDetailUuid() {
    return this._data.trackingDetailUuid
  }
  set trackingDetailUuid(trackingDetailUuid) {
    this._data.trackingDetailUuid = trackingDetailUuid
  }
}
